<!--
 * @Author: zhaoyang
 * @Date: 2020-10-28 16:17:28
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-05 11:10:34
 * @Description: 退款詳情狀態與操作
-->
<template>
  <div class="refound-status">
    <div
      v-if="refoundInfo.orderDto && refoundInfo.orderDto.status == 'Invalid'"
    >
      <p class="header-title">
        <fps-icon
          class="status-icon"
          color="#3BBC2A"
          :type="iconName"
        />
        <span>{{$t('components_order_b_order_detail_594')}}</span>
      </p>
      <p class="status-desc">{{$t('components_order_corder_refound_status_615')}}</p>
    </div>
    <div
      v-if="
        refoundInfo.orderDto && refoundInfo.orderDto.status == 'REFUND_SUCCESS'
      "
    >
      <p class="header-title">
        <fps-icon
          class="status-icon"
          color="#3BBC2A"
          :type="iconName"
        />
        <span>{{$t('components_order_b_order_detail_594')}}</span>
      </p>
      <p class="status-desc">{{$t('components_order_corder_refound_status_616')}}</p>
    </div>
    <div
      v-if="
        refoundInfo.orderDto && refoundInfo.orderDto.status == 'Controversy'
      "
    >
      <p class="header-title">
        <fps-icon
          class="status-icon"
          color="#FE7F38"
          :type="iconName"
        />
        <span>{{$t('components_order_corder_refound_status_617')}}</span>
      </p>
      <h4 class="count-down">{{$t('components_order_corder_refound_status_618')}}{{ comCreateTime | tuiFormartDate }}</h4>
      <p class="status-desc border-desc">
        {{ refoundInfo.orderDto.status | tuiCorderStatus }}
      </p>
    </div>
    <div
      v-if="refoundInfo.orderDto && refoundInfo.orderDto.status == 'Negotiate'"
    >
      <p class="header-title">
        <fps-icon
          class="status-icon"
          color="#FE7F38"
          :type="iconName"
        />
        <span>{{$t('components_order_corder_refound_status_619')}}</span>
      </p>
      <p class="status-desc border-desc">
        {{ refoundInfo.orderDto.status | tuiCorderStatus }}
      </p>
      <reject-detail :refoundInfo="refoundInfo" userType="user"></reject-detail>
    </div>
    <div
      v-if="refoundInfo.orderDto && refoundInfo.orderDto.status == 'Negotiate'"
      class="handles"
    >
      <!-- <div class="handle-button special-button" @click="goRefound">
        繼續退款
      </div> -->
      <div class="handle-button" @click="goService">{{$t('upgrade_page_layout_header_10')}}</div>
      <div class="handle-button" @click="chat">{{$t('components_order_corder_refound_status_620')}}</div>
    </div>
    <div
      v-else-if="
        refoundInfo.orderDto && refoundInfo.orderDto.status == 'REFUND_SUCCESS'
      "
      class="handles"
    >
      <div class="handle-button right-button" @click="chat">{{$t('components_order_corder_refound_status_620')}}</div>
    </div>
  </div>
</template>
<script>
import rejectDetail from './refound-reject-detail';
import { mapGetters } from 'vuex';
const DayGetTime = 86400000; // 24小時對應豪秒數
export default {
  components: {
    rejectDetail,
  },
  props: {
    refoundInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters(['userInfo']),
    comCreateTime() {
      const endTime = new Date(this.refoundInfo.createTimeStamp).getTime();
      const startTime = new Date().getTime();
      return startTime - endTime < 0 ? DayGetTime : DayGetTime - (startTime - endTime);
    },
    iconName() {
      return 'passed';
    },
  },
  methods: {
    goService() {
      // 與客服的會話
      this.$util.openChatWindow(this.userInfo.uuid);
    },
    chat() {
      let uuid = this.refoundInfo.orderDto.playerUserUuid;
      this.$util.openChatWindow(this.userInfo.uuid, uuid);
    },
    goRefound() {
      this.$router.push({
        path: '/b-order-refound',
        query: {
          orderNo: this.orderNo,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.refound-status {
  background: #ffffff;
}
.header-title {
  margin-bottom: 4px;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  color: #222c43;
  display: flex;
  align-items: center;
}
.status-countdown {
  padding: 0 0 20px 26px;
  border-bottom: 1px solid #f1f4f6;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #636d86;
  line-height: 10px;
}
.status-icon {
  margin-right: 6px;
  vertical-align: middle;
}
.status-desc {
  font-size: 12px;
  line-height: 17px;
  color: #636d86;
  margin-top: 3px;
}
.border-desc {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f1f4f6;
}
.count-down {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #636d86;
  margin-left: 24px;
}
.handles {
  padding: 20px 0;
  text-align: right;
}
.handle-button {
  cursor: pointer;
  display: inline-block;
  height: 32px;
  padding: 0 14px;
  border: 1px solid #e8eaee;
  margin-right: 10px;
  font-size: 13px;
  line-height: 32px;
  text-align: center;
  border-radius: 25px;
  color: #636d86;
}
.special-button {
  background: #fed838;
  color: #222c43;
  margin-right: 0;
}
.right-button {
  margin-right: 0;
}
</style>
